import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import * as React from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../hooks/react-redux'
import {feedbackForm} from '../Feedback.slice'

import styles from './FeedbackForm.css'

type Props = {
  final?: boolean
  onSubmit: () => void
  loader?: boolean
  onCancel?: () => void
}

function FeedbackFormControls({final = false, onSubmit, onCancel, loader}: Props) {
  const dispatch = useAppDispatch()

  const commentFieldVisible = useAppSelector(
    state => state.pipelines.feedbackForm.misc.showCommentField,
  )
  const rating = useAppSelector(state => state.pipelines.feedbackForm.userInput.rating)
  const tags = useAppSelector(state => state.pipelines.feedbackForm.userInput.tags)
  const comment = useAppSelector(state => state.pipelines.feedbackForm.userInput.comment)
  const canSubmit = rating !== 0 || comment !== '' || tags.length > 0

  return (
    <div className={classNames(styles.section, styles.controls)}>
      {final ? (
        <Button primary className={styles.submit} onClick={onCancel}>
          {'Got it'}
        </Button>
      ) : (
        <>
          <Button
            disabled={!canSubmit}
            primary
            loader={loader}
            onClick={onSubmit}
            className={styles.submit}
          >
            {'Submit'}
          </Button>
          <Button onClick={onCancel}>{'Skip it'}</Button>
          {!commentFieldVisible ? (
            <Button
              onClick={() => dispatch(feedbackForm.actions.showCommentField(true))}
              text
              className={styles.more}
            >
              {'Write more feedback'}
            </Button>
          ) : null}
        </>
      )}
    </div>
  )
}
export default FeedbackFormControls
